const ASSETS_URL = '/static/assets/fragments';
/**
 * Fetch a fragment metadata from the application assets.
 *
 * @param name - Fragment name.
 */
async function fetchFragmentMetadata(name) {
    const url = ASSETS_URL.concat(`/${name}.json`);
    try {
        const response = await fetch(url, { cache: 'no-cache' });
        const responseJson = await response.json();
        return responseJson;
    }
    catch {
        throw new Error('[Fragment Metadata]: Could not fetch fragment metadata from assets.');
    }
}
export { fetchFragmentMetadata, };
//# sourceMappingURL=fetch-fragment-metadata.js.map